import type { SVGProps } from "react";

export function IconBlackStorefront(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 57.75V26V24.335V18.25V16.75V6.25H57.75V16.75V18.25V23.906C57.7566 24.0482 57.76 24.1912 57.76 24.335H57.7601C57.7601 24.4583 57.7576 24.5814 57.7526 24.7042C57.7518 24.7242 57.7509 24.7441 57.75 24.764V26V57.75H38.75V48C38.75 44.2721 35.7279 41.25 32 41.25C28.2721 41.25 25.25 44.2721 25.25 48V57.75H6.25ZM56.2539 24.6408C56.2579 24.5394 56.26 24.4375 56.26 24.335C56.26 24.2093 56.2569 24.0843 56.2509 23.9602L56.25 23.9421V18.25H7.75V24.335C7.75 26.3466 8.54913 28.2759 9.97159 29.6984C11.3941 31.1208 13.3233 31.92 15.335 31.92C17.3467 31.92 19.2759 31.1208 20.6984 29.6984C22.1149 28.2819 22.9132 26.3629 22.92 24.3604L22.9199 24.335H24.4199L24.42 24.335L24.42 24.3604C24.4267 26.3629 25.2251 28.2819 26.6415 29.6984C28.064 31.1208 29.9933 31.92 32.0049 31.92C34.0166 31.92 35.9459 31.1208 37.3683 29.6984C38.7908 28.2759 39.5899 26.3466 39.5899 24.335L39.5901 24.335H41.0901C41.0901 26.3466 41.8892 28.2759 43.3117 29.6984C44.7341 31.1208 46.6634 31.92 48.6751 31.92C50.5658 31.92 52.3837 31.2141 53.7764 29.9482C53.9298 29.8088 54.0774 29.6632 54.2189 29.5117C55.4588 28.1839 56.1808 26.455 56.2539 24.6408ZM56.25 7.75V16.75H7.75V7.75H56.25ZM37.25 57.75V48C37.25 45.1005 34.8995 42.75 32 42.75C29.1005 42.75 26.75 45.1005 26.75 48V57.75H37.25Z"
        fill="#23232C"
      />
    </svg>
  );
}
